// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YD_345cnMuohhp {
  display: flex;
  flex-shrink: 0;
  align-items: center;
}
.YD_345cnMuohhp.bql28_1VXnI38J {
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
}
._TUxCYptReyC_7 {
  min-width: 32px;
  min-height: 32px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px);
  transition-duration: unset;
}
._TUxCYptReyC_7.bql28_1VXnI38J {
  padding-right: var(--ds-space-050, 4px);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
._TUxCYptReyC_7.bql28_1VXnI38J.pe7kHlQiyovG6d {
  padding: var(--ds-space-075, 6px) var(--ds-space-0, 0) var(--ds-space-075, 6px) var(--ds-space-075, 6px);
}
@container boardHeader (width < 800px) {
  ._TUxCYptReyC_7 {
    padding: var(--ds-space-075, 6px);
  }
  ._TUxCYptReyC_7 .Fk0yUjS2406DOV {
    margin-right: var(--ds-space-0, 0);
  }
  ._TUxCYptReyC_7 .F7r9p3KfD8C0W2 {
    display: none;
  }
}
@keyframes t9opmYwCgezY5f {
  0% {
    opacity: 20%;
  }
  50% {
    opacity: 80%;
  }
  100% {
    opacity: 20%;
  }
}
.laN9mHgXB9oxjH {
  display: block;
  margin-left: var(--ds-space-100, 8px);
  padding-right: 6px;
  padding-left: var(--ds-space-050, 4px);
  border-radius: 20px;
  background-color: var(--dynamic-button-highlighted-hovered, var(--ds-surface, #ffffff));
  color: var(--dynamic-button-highlighted-text, var(--ds-text, #172b4d));
}
.laN9mHgXB9oxjH.LVxkqvKgsBFI5O {
  animation-name: t9opmYwCgezY5f;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  color: transparent;
  -webkit-user-select: none;
          user-select: none;
}
.laN9mHgXB9oxjH.pe7kHlQiyovG6d {
  margin-right: var(--ds-space-0, 0px);
}
.laN9mHgXB9oxjH::before {
  content: '';
  display: inline-flex;
  position: relative;
  top: 1px;
  width: 12px;
  height: 12px;
  margin-right: var(--ds-space-075, 6px);
  border-radius: var(--ds-border-radius-circle, 50%);
  background-color: var(--ds-icon-brand, #0c66e4);
}
.body-light-board-background .laN9mHgXB9oxjH::before {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  background-color: #579dff;
}
.body-dark-board-background .laN9mHgXB9oxjH::before {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  background-color: #0c66e4;
}
.Q9bneVf2iNNMU5 {
  min-width: 32px;
  min-height: 32px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-100, 8px);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.Q9bneVf2iNNMU5 .Fk0yUjS2406DOV {
  display: none;
  margin-right: var(--ds-space-0, 0);
}
@container boardHeader (width < 800px) {
  .Q9bneVf2iNNMU5 {
    padding: var(--ds-space-075, 6px);
  }
  .Q9bneVf2iNNMU5 .F7r9p3KfD8C0W2 {
    display: none;
    padding-right: var(--ds-space-075, 6px);
  }
  .Q9bneVf2iNNMU5 .Fk0yUjS2406DOV {
    display: block;
  }
}
`, ""]);
// Exports
export var buttonGroup = `YD_345cnMuohhp`;
export var isFiltering = `bql28_1VXnI38J`;
export var filterButton = `_TUxCYptReyC_7`;
export var isCollapsed = `pe7kHlQiyovG6d`;
export var buttonIcon = `Fk0yUjS2406DOV`;
export var buttonText = `F7r9p3KfD8C0W2`;
export var filtersCount = `laN9mHgXB9oxjH`;
export var isLoadingCards = `LVxkqvKgsBFI5O`;
export var fadeFiltersCount = `t9opmYwCgezY5f`;
export var clearFiltersButton = `Q9bneVf2iNNMU5`;
export default ___CSS_LOADER_EXPORT___;
